const base = require("./base");
module.exports = {
  ...base.apiFactory(),
  _chat_190606: "https://frontend.cjdropshipping.cn/chat/", // 聊天跳转地址
  _phone_190606: "http://m.cjdropshipping.cn/", // m站挑战地址
  // Whop 引导页「去授权」落点(见 production.js 同名项的说明): cn 验收期指向 cn 站
  _whop_authorize_origin_260922: "https://app.cjdropshipping.cn",
};
